import { useState, Fragment, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import '../css/validationPage.less'
import Search from './components/Search.js';
import UserData from './components/UserData';
import GoToAdmission from './components/GoToAdmission';
import ValidateIdentity from './components/ValidateIdentity';
import { handlers } from '../helpers/helpers';
import config from '../config';

const ValidationPage = ({ refreshUserName, refreshInitialTimeStamp }) => {
  const [patientData, setPatientData] = useState();
  const [step, setStep] = useState(
    JSON.parse(localStorage.getItem("currentValidationStep")) !== null ?
      JSON.parse(localStorage.getItem("currentValidationStep")) : 1
  );
  const { countryCode } = useParams();

  const navigate = useNavigate();

  const getPatientData = () => {
    let _userData = JSON.parse(localStorage.getItem("userData"));
    if (_userData || _userData !== null) {
      if (!_userData.isWonderlicTest) {
        const searchIfWonderlic = _userData.tests.some(test => test && test.code === config.wonderlicCode);
        if (searchIfWonderlic) {
          _userData.tests = _userData.tests.filter((test) => (test && test.groups && test.groups.length > 0) && test.code !== config.wonderlicCode);
        }
        _userData.isWonderlicTest = searchIfWonderlic;

      }
      handlers.handleUserData(_userData);
      setPatientData(_userData);
      if (_userData.tests && _userData.tests.length === 0) {
        navigate(`/examenes/psicologia/${countryCode}/success`);
      }
    }
  }

  const setCurrentStep = (stepName, stepValue) => {
    handlers.handleCurrentStep(stepName, stepValue);
  };

  useEffect(() => {
    window.scroll(0, 0);
    setCurrentStep("currentValidationStep", step);
    getPatientData();
  }, [step]);

  return (
    <Fragment>
      {
        step === 1 &&
        <Search
          setStep={setStep}
          refreshInitialTimeStamp={refreshInitialTimeStamp}
          countryCode={countryCode}
        />
      }
      {
        patientData && step === 2 &&
        <UserData
          setStep={setStep}
          patientData={patientData}
          refreshUserName={refreshUserName}
        />
      }
      {
        step === 3 &&
        <GoToAdmission
          setStep={setStep}
        />
      }
      {
        patientData && step === 4 &&
        <ValidateIdentity
          patientData={patientData}
          countryCode={countryCode}
        />
      }
    </Fragment>
  );
};

export default ValidationPage;